<template>
  <div class="phone">
    <header>
      <div class="title">
        <span class="back" @click="goBack">◀</span>
        <span>{{ $t('订单记录') }}</span>
      </div>
    </header>

    <main>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div v-for="order in list" :key="order.id" class="order-card">
            <div class="order-header">
              <span class="order-state">{{ getStateText(order.state) }}</span>
            </div>
            <div class="order-info">
              <div class="info-row">
                <span class="label">{{ $t('支付时间') }}：</span>
                <span class="value">{{ formatDate(order.payTime) }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ $t('业务号') }}：</span>
                <span class="value">{{ order.no }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ $t('商品类型') }}：</span>
                <span class="value">{{ order.goodsName }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ $t('订单金额') }}：</span>
                <span class="value amount">{{ formatMoney(order.totalAmount) }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ $t('佣金收益') }}：</span>
                <span class="value commission">+{{ formatMoney(order.commissionAmount) }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </main>
  </div>
</template>

<script>
import { getTaskOrderPage } from "@/api/task"

export default {
  name: "TaskOrderList",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      curPage: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    async fetchOrders() {
      const params = {
        curPage: this.curPage,
        pageSize: this.pageSize,
        orders: [{column: "`create_time`", asc: false}]
      }
      try {
        const res = await getTaskOrderPage(params)
        let records = []
        let total = 0
        if (res && res.data) {
          if (res.data.records) {
            records = res.data.records
          } else if (res.data.list) {
            records = res.data.list
          }
          if (res.data.total !== undefined && res.data.total !== null) {
            total = parseInt(res.data.total)
          }
        }
        if (this.refreshing) {
          this.list = records
          this.refreshing = false
        } else {
          this.list = this.list.concat(records)
        }
        this.finished = this.list.length >= total
      } catch (error) {
        console.error("加载订单失败:", error)
        this.$toast.fail(this.$t('加载失败'))
      } finally {
        this.loading = false
      }
    },
    onLoad() {
      if (!this.finished && !this.loading) {
        this.curPage++
        this.fetchOrders()
      }
    },
    onRefresh() {
      this.curPage = 1
      this.finished = false
      this.list = []
      this.fetchOrders()
    },
    getStateText(state) {
      if (state === 'INIT') return this.$t('待结算')
      if (state === 'FINISH') return this.$t('已结算')
      if (state === 'CANCEL') return this.$t('已取消')
      return state
    },
    formatDate(dateStr) {
      if (!dateStr) return '--'
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    },
    formatMoney(value) {
      if (value === undefined || value === null) return '0.00'
      return Number(value).toFixed(2)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.phone {
  width: min(100vw, 383px);
  min-height: 100vh;
  background: #f7f8fa;
  margin: 0 auto;
  box-shadow: 0 0 0 1px rgba(18, 33, 59, 0.04), 0 24px 70px rgba(15, 31, 57, 0.12);
}
header {
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  background: linear-gradient(135deg, #111318 0%, #171a22 58%, #222630 100%);
  position: sticky;
  top: 0;
  z-index: 5;
}
.title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  font-size: 18px;
  color: #fff;
}
.back {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  background: linear-gradient(135deg, #25f4ee 0 47%, #fe2c55 48% 100%);
  color: #111318;
  font-weight: 900;
  font-size: 11px;
  cursor: pointer;
  margin-right: 8px;
}
main {
  padding: 14px;
}
.order-card {
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
}
.order-no {
  color: #333;
}
.order-state {
  color: #fe2c55;
  font-size: 12px;
  background: #ffe8eb;
  padding: 2px 8px;
  border-radius: 20px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  padding: 6px 0;
}
.label {
  color: #7a8799;
}
.value {
  color: #15243a;
}
.amount {
  color: #ff3b61;
  font-weight: 600;
}
.commission {
  color: #25f4ee;
  font-weight: 600;
}
</style>